import { useEffect } from "react";
import { Outlet, useLocation } from "react-router-dom";
import { AREA_THEME, ROUTES, keyForPath } from "@/content/routes";
import { cn } from "@/lib/utils";
import { PrototypeBar } from "./PrototypeBar";
import { SiteHeader } from "./SiteHeader";
import { SiteFooter } from "./SiteFooter";

const useScrollAndTitle = (key) => {
  const { pathname, hash } = useLocation();
  useEffect(() => {
    document.title = key && key !== "home" ? `${ROUTES[key].label} · Ordo Intelligence` : "Ordo Intelligence · Phase 1 Prototype";
  }, [key]);
  useEffect(() => {
    const el = hash ? document.getElementById(hash.slice(1)) : null;
    if (el) {
      el.scrollIntoView();
    } else {
      window.scrollTo(0, 0);
    }
  }, [pathname, hash]);
};

export default function Layout() {
  const { pathname } = useLocation();
  const key = keyForPath(pathname);
  const theme = AREA_THEME[key ? ROUTES[key].area : "home"];
  useScrollAndTitle(key);
  return (
    <div className={cn(theme, "min-h-screen bg-o-bg text-o-text")} data-testid="site-shell">
      <a href="#main" className="sr-only focus:not-sr-only focus:fixed focus:left-4 focus:top-4 focus:z-[60] focus:bg-o-accent focus:px-4 focus:py-2 focus:text-o-accent-ink">
        Skip to content
      </a>
      <PrototypeBar />
      <SiteHeader currentKey={key} theme={theme} />
      <main id="main">
        <Outlet />
      </main>
      <SiteFooter />
    </div>
  );
}
